var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashrotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70713 8.90711C1.31661 9.29763 0.683442 9.29763 0.292918 8.90711C-0.0976067 8.51658 -0.0976067 7.88342 0.292918 7.49289L1.70713 8.90711ZM16.1071 7.49289C16.4977 7.88342 16.4977 8.51658 16.1071 8.90711C15.7166 9.29763 15.0834 9.29763 14.6929 8.90711L16.1071 7.49289ZM7.13936 2.06066L7.84647 2.76777L7.13936 2.06066ZM14.6929 8.90711L8.55358 2.76777L9.96779 1.35355L16.1071 7.49289L14.6929 8.90711ZM7.84647 2.76777L1.70713 8.90711L0.292918 7.49289L6.43226 1.35355L7.84647 2.76777ZM8.55358 2.76777C8.35832 2.5725 8.04173 2.5725 7.84647 2.76777L6.43226 1.35355C7.40857 0.377243 8.99148 0.377242 9.96779 1.35355L8.55358 2.76777Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashrotate);
export default __webpack_public_path__ + "static/media/flashrotate.bcfa83cfe7b624012303c29ac7b0acf8.svg";
export { ForwardRef as ReactComponent };